import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CallState } from './call.reducers';

export const callsFeatureStateSelector = createFeatureSelector<CallState>('call');

export const selectCalls = createSelector(callsFeatureStateSelector, (state: CallState) => state.calls);
export const selectCallsTotalCount = createSelector(callsFeatureStateSelector, (state: CallState) => state.callsTotalCount);
